import { FC } from 'react'
import { Link } from 'react-router-dom'
import { img } from '../assets/assets'
import { Container } from '../components/Container'
import { Button } from '../components/UI/Buttons'

export const Error404: FC = () => {
    return (
        <Container>
            <div className="error">
                <div className="error__logo">
                    <img src={img.error404} alt="" />
                </div>
                <div className="error__title">Page Not Found</div>
                <div className="error__text">
                    You have reached a page that does not exist, or you went to
                    the wrong address. Don't worry, try starting over.
                </div>
                <div className="error__button">
                    <Link to="/">
                        <Button rounded>Home page</Button>
                    </Link>
                </div>
            </div>
        </Container>
    )
}
